import dustCollector12000Cmh from './dust_collector/12000 CMH DUST COLLECTOR.png';
import dustCollector16000Cmh from './dust_collector/16000 CMH DUST COLLECTOR.png';
import dustCollector20_24_28_32000Cmh from './dust_collector/20-24-28-32000 CMH DUST COLLECTOR.png';

export const dustCollectorImages = {
    dustCollector12000Cmh,
    dustCollector16000Cmh,
    dustCollector20_24_28_32000Cmh,
};

export const cycloneImages = {
    dustCollector12000Cmh,
    dustCollector16000Cmh,
    dustCollector20_24_28_32000Cmh,
};

const proposalImages = {
    dustCollector: dustCollectorImages,
    cyclone: cycloneImages,
};


const imageConfigs = {
    oven:{
        
    },
    dust_collector: {
        dc_3000: [dustCollector12000Cmh],
        dc_6000: [dustCollector12000Cmh],
        dc_8000: [dustCollector12000Cmh],
        dc_10000: [dustCollector12000Cmh],
        dc_12000: [dustCollector12000Cmh],
        dc_16000: [dustCollector16000Cmh],
        dc_20000: [dustCollector20_24_28_32000Cmh],
        dc_24000: [dustCollector20_24_28_32000Cmh],
        dc_28000: [dustCollector20_24_28_32000Cmh],
        dc_32000: [dustCollector20_24_28_32000Cmh],
    },
    cyclone: {
        dc_3000: [dustCollector12000Cmh],
        dc_6000: [dustCollector12000Cmh],
        dc_8000: [dustCollector12000Cmh],
        dc_10000: [dustCollector12000Cmh],
        dc_12000: [dustCollector12000Cmh],
        dc_16000: [dustCollector16000Cmh],
        dc_20000: [dustCollector20_24_28_32000Cmh],
        dc_24000: [dustCollector20_24_28_32000Cmh],
        dc_28000: [dustCollector20_24_28_32000Cmh],
        dc_32000: [dustCollector20_24_28_32000Cmh],
    },

}
export { imageConfigs };
export default proposalImages;
